import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import SelectListField from "../../../components/Fields/SelectListField";
import { FormConfig } from "../../../components/Fields/Types";
import useSelectListOptions from "../../../components/Hooks/SelectListOptionsHook/useSelectListOptions";
import useValidation from "../../../components/Hooks/ValidationHook/useValidation";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";

interface Props extends PopupProps {
    employeeId: number
}
interface CreateModel {
    employeeId: number
    divisionId: number
}

const AddEmployeeDivisionPopup: React.FC<Props> = ({ show, onHide, employeeId }) => {
    const [serverErrors, setServerErrors] = useState<Result>({ isSuccesful: true, messages: [] });
    const [formData, setFormData] = useState<CreateModel>({
        employeeId: employeeId,
        divisionId: 0,
    });

    const divisions = useSelectListOptions('api/v1/selectlist/Divisions', '-- Select division');
    const { handleResult, handleException } = useNotifications();

    function submit() {
        if (formData) {
            DataService
                .create<CreateModel>(`api/v1/EmployeeDivisions`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true) {
                        if (onHide)
                            onHide();
                    }
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'divisionId', label: 'Division', labelSize: 3, validationRules: [{ type: 'isRequired' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add Division'} >
            <Popup.Body>
                <SelectListField {...getFieldProps('divisionId')} options={divisions} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton text='Add' {...getSubmitButtonProps()} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddEmployeeDivisionPopup;